<script setup lang="ts">
definePage({
  name: '/jobs/ai',
  meta: {
    layout: 'empty',
  },
})

await useStoreInitializer([ 'CompanyStore', 'StaticDataStore' ], [
  'DashboardStore',
  'JobConverterStore',
  'JobStore', 
])
</script>

<template>
  <router-view v-slot="{ Component }">
    <suspense>
      <component :is="Component" />
    </suspense>
  </router-view>
</template>
